import { Component, createRef } from "react";
import { connect } from "react-redux";
import { withStyles } from "@mui/styles";
import {
    AppBar,
    Dialog,
    DialogContent,
    Fab,
    Icon,
    IconButton,
    Toolbar,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { compose } from "redux";
import ZoomIcon from "@mui/icons-material/ZoomOutMap";
import Annotation from "react-image-annotation";
import { PointSelector } from "react-image-annotation/lib/selectors";
import { siteMonitoringIsDisabled } from "../../redux/siteMonitoring/siteMonitoringActions";
import Zoom from "../Basics/Zoom";
import FooterFixedOnScreen from "../../containers/Layout/FooterFixedOnScreen";

const styles = {
    icon: {
        color: "#D50000",
    },
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class MarkablePlan extends Component {
    constructor(props) {
        super(props);

        this.state = {
            annotation: {},
            modalOpened: false,
            tool: PointSelector,
            disableEditor: true,
            disableOverlay: true,
            disableAnnotation: false,
            disableSelector: false,
            creatingNote: false,
        };

        this.markablePlanRef = createRef();
    }

    closePlan() {
        this.setState({
            modalOpened: false,
        });
    }

    onPhotoClick() {
        this.setState({
            modalOpened: true,
        });
    }

    Box = (props) => {
        let { children, geometry, style } = props;
        let left = geometry.x;
        let right = undefined;
        let float = "left";

        if (geometry.x > 50) {
            left = undefined;
            right = 100 - geometry.x;
            float = "right";
        }

        left = left ? "calc(" + left + "% - 1vh)" : undefined;
        right = right ? "calc(" + right + "% - 1vh)" : undefined;

        return (
            <div
                {...props}
                style={{
                    ...style,
                    position: "absolute",
                    float: `${float}`,
                    left: `${left}`,
                    right: `${right}`,
                    top: `calc(${geometry.y}% - 1vh`,
                    height: `${geometry.height}%`,
                    width: `${geometry.width}%`,
                }}
            >
                {children}
            </div>
        );
    };

    renderEditor(obj) {
        const { annotation, onSubmit } = obj;
        const { geometry } = annotation;
        if (!geometry) return null;

        geometry.width = "100%";
        geometry.maxWidth = "400px";

        onSubmit(annotation);

        return null;
    }

    renderMarker({ annotation }) {
        const { geometry } = annotation;
        if (!geometry) return null;

        return (
            <this.Box key={annotation.data.noteMobileId} geometry={geometry}>
                <div
                    key={annotation.data.noteMobileId}
                    style={{
                        border: "solid 5px #FE5815",
                        borderRadius: "100%",
                        width: "1px",
                    }}
                ></div>
            </this.Box>
        );
    }

    creatingNote = (annotation) => {
        if (this.state.creatingNote) {
            this.props.onCreatingAnnotation(annotation);
            this.cancelAddingNote();
        } else {
            const x = annotation.geometry.x;
            const y = annotation.geometry.y;

            // Determine if there are any annotations that exist that are within 1 unit of where the user clicked
            let closeAnnotations = this.props.annotations.filter(
                (stateAnnotation) => {
                    let distanceFromX = Math.abs(
                        x - stateAnnotation.geometry.x
                    );
                    let distanceFromY = Math.abs(
                        y - stateAnnotation.geometry.y
                    );

                    return distanceFromX < 1 && distanceFromY < 1;
                }
            );

            // If there are existing annotations we want to activate one of them instead of creating a new one
            let existingAnnotation = null;
            if (closeAnnotations.length > 0) {
                existingAnnotation = JSON.parse(
                    JSON.stringify(closeAnnotations[0])
                ); // we wrap the object with parse and stringfy to copy the object without holding a reference to the annotation in the state
            }

            // If the set annotation an existing one we need to manually update the text on the object or else it won't ever change
            if (annotation.data && annotation.data.text) {
                existingAnnotation.data.text = annotation.data.text;
            }
            if (existingAnnotation) this.editingNote(existingAnnotation);
        }
    };

    editingNote = (annotation) => {
        this.props.onEditingNote(annotation);
    };

    onNoteSubmit = () => {
        this.cancelAddingNote();
    };

    activeAnnotationComparator = (a, b) => {
        return a.data.noteMobileId === b;
    };

    addingNote() {
        this.setState({
            disableEditor: false,
            disableAnnotation: false,
            disableSelector: true,
            creatingNote: true,
        });
    }

    cancelAddingNote() {
        this.setState({
            disableEditor: true,
            disableAnnotation: false,
            disableSelector: false,
            creatingNote: false,
        });
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <div
                    className="photo-auto-size"
                    onClick={this.onPhotoClick.bind(this)}
                >
                    <img
                        {...this.props.inputProperties}
                        src={this.props.file}
                        alt="Aperçu"
                        className="minify-photo"
                    />
                    <ZoomIcon className="photo-center-icon white-icon" />
                </div>
                <Dialog
                    fullScreen
                    open={this.state.modalOpened}
                    onClose={this.closePlan.bind(this)}
                >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                onClick={this.closePlan.bind(this)}
                                aria-label="Close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography
                                variant="h6"
                                color="inherit"
                                className={classes.flex}
                            >
                                {this.props.planName}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Toolbar/>
                    <DialogContent className="without-side-padding container-with-footer">
                        <Zoom>
                            <div
                                style={{
                                    maxWidth: "1920px",
                                    maxHeight: "1920px",
                                }}
                            >
                                <Annotation
                                    ref={this.markablePlanRef}
                                    src={
                                        this.props.file ? this.props.file : null
                                    }
                                    annotations={this.props.annotations}
                                    value={{
                                        data: this.props.currentAnnotationData,
                                    }}
                                    onChange={this.creatingNote}
                                    onSubmit={this.onNoteSubmit}
                                    type={this.state.tool.TYPE}
                                    activeAnnotationComparator={
                                        this.activeAnnotationComparator
                                    }
                                    disableOverlay={this.state.disableOverlay}
                                    disableEditor={this.state.disableEditor}
                                    disableSelector={this.state.disableSelector}
                                    disableAnnotation={
                                        this.state.disableAnnotation
                                    }
                                    renderEditor={this.renderEditor.bind(this)}
                                    renderHighlight={this.renderMarker.bind(
                                        this
                                    )}
                                />
                            </div>
                        </Zoom>
                        {!siteMonitoringIsDisabled(
                            this.props.siteMonitoring,
                            this.props.activeUser
                        ) ? (
                            <FooterFixedOnScreen>
                                <div className="row">
                                    {!this.state.creatingNote ? (
                                        <div className="offset-lg-10 col-lg-2 offset-md-10 col-md-2 offset-sm-8 col-sm-4 offset-8 col-4">
                                            <div className="center">
                                                <Fab
                                                    onClick={this.addingNote.bind(
                                                        this
                                                    )}
                                                    color="primary"
                                                    className="div-center"
                                                >
                                                    <Icon>add</Icon>
                                                </Fab>
                                                <span className="floating-btn-text span-center">
                                                    Créer note
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            {this.state.creatingNote ? (
                                                <Typography
                                                    className="col-lg-10 col-md-10 col-sm-8 col-8 white-text"
                                                    variant="inherit"
                                                >
                                                    Cliquez sur le plan pour
                                                    créer la note
                                                </Typography>
                                            ) : null}
                                            <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                                                <div className="center">
                                                    <Fab
                                                        onClick={this.cancelAddingNote.bind(
                                                            this
                                                        )}
                                                        className="red-button div-center"
                                                    >
                                                        <Icon>arrow_back</Icon>
                                                    </Fab>
                                                    <span className="floating-btn-text span-center">
                                                        Annuler
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </FooterFixedOnScreen>
                        ) : null}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(MarkablePlan);
